import { MutationTree } from 'vuex';
import { initialState } from './index'
import { Item, ModuleState } from './types'

export const mutations: MutationTree<ModuleState> = {
  handleResponse(state, payload: { items: Item[] }) {
    state.error = false;
    state.items = payload.items;
  },
  handleError(state) {
    state.error = true;
    state.items = [];
  },
  reset(state) { Object.assign(state, initialState) }
};
